<template>
    <div class="page">
        <div id="posterHtml" class="section" v-if="!posterImg">

            <img src="@/assets/image/bill/title-logo.png" class="title" alt="">
            <h6 v-if="keywordFont" class="keyword">祝您2021{{keywordFont}}</h6>

            <!-- 二维码 -->
            <qrcode :url="codeValue" :iconurl="imageUrl"
                    :wid="150" :hei="150" :imgwid="40" :imghei="40"></qrcode>
            <p class="tip">扫描上方二维码查看年度账单</p>
        </div>
        <div class="posterImg" style="height:100%">
            <img v-if="posterImg" :src="posterImg"
                 class="title" style="width:100%;height:100%;" alt="">
        </div>
    </div>
</template>

<script>
    import html2canvas from "html2canvas";
    import qrcode from 'vue_qrcodes'

    export default {
        components: {
            qrcode
        },
        data(){
            return{
                codeValue: 'http://h5.cleverplanting.com/#/bill',
                keywordFont:'',
                imageUrl: require("@/assets/image/bill/logo.png"), //默认二维码中间图片

                posterHtmlBg: require('@/assets/image/bill/zhandan1.png'), // 背景图
                posterImg: '', // 最终生成的海报图片
            }
        },
        created() {
            const {UserId,keywordFont} = this.$route.query || {}
            if(UserId){
                this.codeValue += `?UserId=${UserId}`
                this.keywordFont = keywordFont
            }else{
                this.$notify('未查询到用户ID,请重新访问有效链接')
            }
            setTimeout(()=>{
                this.createPoster()
            },1)
        },
        methods:{
            createPoster() {
                // 生成海报
                const targetDom  = document.getElementById('posterHtml')
                html2canvas(targetDom).then(canvas => {
                    // 将图片src替换为canvas生成之后转换的url
                    this.posterImg = canvas.toDataURL();
                    // console.log('海报：',canvas.toDataURL())
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '@/styles/bill/billShareImg';
</style>
